import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AdjacentType, DeviceState, GatewayState } from '@iotv/datamodel-core';
import { AppValueTypes, ComparisonType, LogicalOperatorType } from '@iotv/iotv-v3-types';
import { Button, Typography } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import AppDao from '../../../data/AppDao';
import { getCustomerHierarchy } from '../../../data/RoleQueries';
import { getItems } from '../../../data/Wideawake/wideawakeDataFns';
import { useSelectedObjects } from '../../../hooks/useSelectedObjects';
import { StaticLoadingAnimation } from '../../../Popup/Loading';
import { ComponentMode, ObjectViewType } from '../../../types/AppTypes';
import { ListerlizerAdapter } from '../../factories/Listerlizer/legacy/ListerlizerAdapter';
import ModalContainer from '../../Modal/ModalContainer';
import ProvisionCard from './ProvisionCard';
const getGateways = async () => {
    const res = await getItems({ objectTypeId: 'Gateway' });
    if (res.err === null && res.data) {
        const allItems = res.data.Items;
        const items = allItems.filter((item) => item.state === GatewayState.INVENTORY);
        return items;
    }
    else {
        return [];
    }
};
/** @deprecated - No longer used */
const GatewayAssignmentCard = (props) => {
    const { user, contextCustomer, userFunctions, transactionFunctions } = props;
    const { state: [[selectedObjects, setSelectedObjects]], } = useSelectedObjects();
    const [gateways, setGateways] = useState(null);
    const [filteredGateways, setFilteredGateways] = useState([]);
    const [childCustomers, setChildCustomers] = useState();
    const [provisionModal, setProvisionModal] = useState(false);
    const [customerMapper, setCustomerMapper] = useState();
    const getGatewaysListerlizer = (context) => {
        const baseQueryFilter = [
            {
                filters: [
                    {
                        key: 'state',
                        value: DeviceState.INVENTORY,
                        predicate: ComparisonType.EQUALS,
                    },
                ],
                setOperation: LogicalOperatorType.AND,
            },
        ];
        return {
            initMode: ComponentMode.EDIT,
            transactionFunctions,
            userFunctions,
            adjacentFilter: {
                adjacentType: AdjacentType.CHILD,
                objectType: 'Gateway',
                filterConfig: baseQueryFilter,
            },
            autoQuery: true,
            columnVisibilityReferences: {
                dataTableReference: 'List',
                objectTypeId: 'ValidBusinessObject',
                viewType: ObjectViewType.List,
                externalColumnVisibility: undefined,
            },
            viewDefinition: {
                name: {
                    key: 'name',
                    type: AppValueTypes.STRING,
                    label: 'Gateway',
                    editable: false,
                    precision: undefined,
                    stateFn: undefined,
                    unit: undefined,
                    validationRx: undefined,
                    enumKV: undefined,
                },
                id: {
                    key: 'id',
                    type: AppValueTypes.STRING,
                    label: 'ID',
                    editable: false,
                    precision: undefined,
                    stateFn: undefined,
                    unit: undefined,
                    validationRx: undefined,
                    enumKV: undefined,
                },
                group: {
                    key: 'group',
                    type: AppValueTypes.STRING,
                    label: 'Group',
                    editable: false,
                    precision: undefined,
                    stateFn: undefined,
                    unit: undefined,
                    validationRx: undefined,
                    enumKV: undefined,
                },
                customer: {
                    key: 'customer',
                    type: AppValueTypes.STRING,
                    label: 'Customer',
                    editable: false,
                    precision: undefined,
                    stateFn: undefined,
                    unit: undefined,
                    validationRx: undefined,
                    enumKV: undefined,
                },
                lastSeen: {
                    key: 'lastSeen',
                    type: AppValueTypes.DATE,
                    label: 'Last Seen',
                    editable: false,
                    precision: undefined,
                    stateFn: undefined,
                    unit: undefined,
                    validationRx: undefined,
                    enumKV: undefined,
                },
            },
            viewObject: {
                matchedPrimary: undefined,
                matchedRelatedByPk: [],
                matchedRelatedBySk: context,
            },
            contextObject: undefined,
            searchRootObject: undefined,
            onSelectedUpdate: setSelectedObjects,
        };
    };
    const updateGateways = () => {
        getGateways().then((res) => {
            setGateways(res);
        });
    };
    useEffect(() => {
        updateGateways();
    }, []);
    useEffect(() => {
        const getHydratedGateways = async (gatewayList) => {
            const mapperPromise = await AppDao.queryByGraph({
                contextObjects: gatewayList,
                path: [
                    { objectTypeId: 'Group', adjacencyType: AdjacentType.PARENT },
                    { objectTypeId: 'Customer', adjacencyType: AdjacentType.PARENT },
                ],
            });
            if (mapperPromise.err === null && mapperPromise.data !== null) {
                const mapper = mapperPromise.data;
                setCustomerMapper(mapper);
                const hydratedGateway = gatewayList.map((gateway) => {
                    const copy = { ...gateway };
                    const groups = mapper.getParentNodes(gateway);
                    if (groups.length > 0) {
                        copy.group = groups.map((group) => group.name).join(', ');
                        const customer = mapper.getParentNodes(groups[0]);
                        if (customer.length === 1) {
                            copy.customer = customer[0].name;
                        }
                    }
                    return copy;
                });
                return hydratedGateway;
            }
            else {
                return gatewayList;
            }
        };
        if (gateways) {
            getHydratedGateways(gateways).then((newGateway) => {
                setFilteredGateways(newGateway);
            });
        }
    }, [gateways]);
    useEffect(() => {
        if (contextCustomer) {
            getCustomerHierarchy(contextCustomer).then((customersResponse) => {
                if (customersResponse.err === null && customersResponse.data !== null) {
                    let options = customersResponse.data.nodes;
                    options = options.filter((option) => option.id !== contextCustomer.id);
                    setChildCustomers(options);
                }
                else {
                    console.error('No customers found');
                    setChildCustomers([]);
                }
            });
        }
    }, [contextCustomer]);
    const closeProvisioning = async () => {
        updateGateways();
        setProvisionModal(false);
    };
    const openAssignment = useCallback(() => {
        setProvisionModal(true);
    }, []);
    return (_jsxs("div", { children: [_jsx(Typography, { component: "h6", variant: "h6", children: "Assign Gateways to Customers" }), _jsx(Button, { variant: "contained", color: "primary", disabled: selectedObjects.length === 0, onClick: openAssignment, children: "Assign" }), _jsx("br", {}), _jsx("br", {}), gateways ? _jsx(ListerlizerAdapter, { ...getGatewaysListerlizer(filteredGateways) }) : _jsx(StaticLoadingAnimation, { message: 'Retrieving Gateway Details' }), provisionModal && childCustomers && contextCustomer && customerMapper && user && (_jsx(ModalContainer, { children: _jsx(ProvisionCard, { user,
                    customerOptions: childCustomers,
                    devices: selectedObjects,
                    close: closeProvisioning,
                    contextCustomer,
                    userFunctions,
                    customerMapper,
                    transactionFunctions }) }))] }));
};
export default GatewayAssignmentCard;
